import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.tiposdecosto.edit}
                postUrl={api.proyectos.config.presupuesto.tiposdecosto.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}

                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"El Tipo de Costo ha sido editado con éxito."}
                title={"Editar Tipo de Costo"}
                buttonTitle={"Editar Tipo de Costo"}
                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}>
                <ParadigmaLabeledInput fieldName="nombre" label="Nombre" labelColumns={2} fieldColumns={10} />
                <ParadigmaLabeledInput fieldName="siglas" label="Siglas" labelColumns={2} fieldColumns={10} />
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_TiposDeCosto/Edit.js